module.exports = __webpack_public_path__ + "img/product_icon_vpa.6db95a43.png";